var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01669 12.65C2.25002 12.8833 2.53507 13 2.87182 13H6.76026C6.69882 12.6761 6.66667 12.3418 6.66667 12C6.66667 10.5226 7.26741 9.18547 8.23794 8.21961L8 8.37175L2.66667 4.9615L2.76924 3.99998L8 7.33332L13.2308 3.99998L13.3333 4.9615L10.1527 6.99525C10.7283 6.78273 11.3506 6.66667 12 6.66667C12.8368 6.66667 13.6285 6.85937 14.3333 7.20282V4.20513C14.3333 3.86838 14.2167 3.58333 13.9833 3.35C13.75 3.11667 13.4649 3 13.1282 3H2.87182C2.53507 3 2.25002 3.11667 2.01669 3.35C1.78335 3.58333 1.66669 3.86838 1.66669 4.20513V11.7948C1.66669 12.1316 1.78335 12.4166 2.01669 12.65ZM14.3333 9.61951C13.7321 9.0301 12.9085 8.66667 12 8.66667C10.1591 8.66667 8.66667 10.1591 8.66667 12C8.66667 12.3484 8.72011 12.6843 8.81926 13H13.1282C13.4649 13 13.75 12.8833 13.9833 12.65C14.2167 12.4166 14.3333 12.1316 14.3333 11.7948V9.61951Z",
    fill: "#4CAF50"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0003,
    r: 3.33333,
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3604 14V12.7604C13.3604 12.5857 13.313 12.4388 13.2183 12.3195C13.1235 12.2002 13.0068 12.1406 12.868 12.1406H11.2132L11.8274 12.9137L11.3807 13.476L10 11.738L11.3807 10L11.8274 10.5623L11.2132 11.3355H12.868C13.1794 11.3355 13.4459 11.475 13.6675 11.754C13.8892 12.033 14 12.3685 14 12.7604V14H13.3604Z",
    fill: "#E5FFEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyReceived);
export default __webpack_public_path__ + "static/media/reply-received.50f9710b338a575f48e1807135e1f831.svg";
export { ForwardRef as ReactComponent };